// Evidence list + document row.  Used by gate review's supporting documents card.

import { humanizeEnum } from '../../lib/fieldLabels.js';

function typeIcon(type) {
  const t = String(type || '').toLowerCase();
  if (t.includes('pdf')) return { glyph: 'PDF', tone: 'brick' };
  if (t.includes('xls') || t.includes('sheet')) return { glyph: 'XLS', tone: 'sage' };
  if (t.includes('doc') || t.includes('word')) return { glyph: 'DOC', tone: 'blue' };
  if (t.includes('img') || t.includes('png')) return { glyph: 'IMG', tone: 'amber' };
  return { glyph: 'DOC', tone: 'slate' };
}

export function DocumentRow({ artifact, onOpen, onAddNote }) {
  const ic = typeIcon(artifact.type || artifact.documentType || artifact.format);
  return (
    <div className="document-row">
      <div className={`document-type chip sm ${ic.tone}`} aria-hidden>
        {ic.glyph}
      </div>
      <div className="document-body">
        <div className="document-title">{artifact.title || artifact.name || artifact.id}</div>
        <div className="document-meta">
          {humanizeEnum(artifact.reviewState || artifact.status || 'evidence')} · v
          {artifact.version || 1}
          {artifact.ownerUserId ? ` · ${artifact.ownerUserId}` : ''}
          {artifact.classificationLabel ? ` · ${artifact.classificationLabel}` : ''}
        </div>
        {artifact.aiGenerated ? (
          <span className="chip blue sm" style={{ marginTop: 4 }}>
            AI generated · pending human review
          </span>
        ) : null}
      </div>
      <div className="document-actions">
        {onOpen ? (
          <button className="btn ghost sm" onClick={() => onOpen(artifact)}>
            Open
          </button>
        ) : null}
        {onAddNote ? (
          <button className="btn link sm" onClick={() => onAddNote(artifact)}>
            Add note
          </button>
        ) : null}
      </div>
    </div>
  );
}

export function EvidenceList({
  artifacts = [],
  onOpenArtifact,
  onAddNote,
  emptyTitle = 'No evidence recorded',
}) {
  if (!artifacts.length)
    return (
      <div className="empty-state">
        <h3 style={{ margin: 0 }}>{emptyTitle}</h3>
        <p>Linked artifacts will appear here when uploaded or generated.</p>
      </div>
    );
  return (
    <div className="evidence-list">
      {artifacts.map((a) => (
        <DocumentRow key={a.id} artifact={a} onOpen={onOpenArtifact} onAddNote={onAddNote} />
      ))}
    </div>
  );
}
